import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { IModuleHasDashboardPublishedDto, ModuleDashboards } from "./module-dashboards";
import { ICategory, IDashboardView } from "@main/reporting.v3/dashboard/dashboard-models";

@Injectable({
    providedIn: "root"
})
export class ModuleReportsService extends BaseDataService {
    public readonly url = "api/reporting3/module-report";

    constructor(
        http: HttpClient,
        handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getModuleDashboards(moduleName: string): Promise<ModuleDashboards> {
        return this.handleRequest<ModuleDashboards>(
                this.http.get<ModuleDashboards>(`${this.url}/${moduleName}`),
                this.handlersFactory.getDefault());
    }

    getDashboard(dashboardId: string) {
        return this.handleRequest(this.http.get<IDashboardView>(`${this.url}/dashboard/${dashboardId}`));
    }

    getCategories(): Promise<ICategory[]> {
        return this.handleRequest<ICategory[]>(
            this.http.get<ICategory[]>(`${this.url}/categories`),
            this.handlersFactory.getDefault());
    }

    async moduleHasDashboardPublished(moduleName: string): Promise<boolean>{
        return this.handleRequest<boolean>(
            this.http.get<boolean>(`${this.url}/moduleHasDashboardPublished/${moduleName}`),
            this.handlersFactory.getDefault());
    }

    async modulesHasDashboardPublished(moduleNames: string[]): Promise<IModuleHasDashboardPublishedDto[]> {
        const params = new HttpParams({ fromObject: { moduleNames } });
        return this.handleRequest<IModuleHasDashboardPublishedDto[]>(
          this.http.get<IModuleHasDashboardPublishedDto[]>(`${this.url}/modulesHasDashboardPublished`, { params }),
          this.handlersFactory.getDefault()
        );
    }
}